function setupForDark(...classnames: string[]): string {
  let result = [];
  classnames.forEach((classname) => {
    classname.split(/\s+/).forEach((c) => {
      result.push(`${c} dark:${c}-dark`);
    });
  });
  return result.join(' ');
}

const styleForScore = (score: number, mid: number, high: number, colorPrefix: string) => {
  if (score >= high) {
    return `${colorPrefix}-green-300`;
  } else if (score >= mid) {
    return `${colorPrefix}-yellow-300`;
  } else {
    return `${colorPrefix}-red-300`;
  }
};

export { setupForDark, styleForScore };
